import { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import PaymentRecordsTable from "../../../../components/Admin/PaymentHistory/PaymentRecordsTable";
import PaymentHistoryTable from "../../../../components/Shared/PaymentHistoryTable";
import { usePaymentStore } from "../../../../config/admin.stores";
import adminService from "../../../../services/admin.service";

const AdminPaymentHistory = () => {
    const [tab, setTab] = useState(0);
    const paymentStore = usePaymentStore();

    const handleTabChange = (_event: any, newValue: number) => {
        setTab(newValue);
    };
    
    return (
        <Box display="flex" flexDirection="column" alignItems="left" gap={3} margin={3}>
            <Box display="flex" justifyContent="space-between" sx={{ alignItems: "center", position: 'relative' }}>
                <Typography variant="h5">All Payment History</Typography>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleTabChange}>
                    <Tab label="Manage Database Records" id="database-tab" aria-controls="database-tabpanel"/>
                    <Tab label="Succeeded Payments" id="succeeded-tab" aria-controls="succeeded-tabpanel"/>
                    <Tab label="Failed Payments" id="failed-tab" aria-controls="failed-tabpanel"/>
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== 0} id="database-tabpanel" aria-labelledby="database-tab">
                {tab === 0 &&
                    <PaymentRecordsTable
                        records={paymentStore.adminPaymentHistory}
                        setRecords={paymentStore.setAdminPaymentHistory}
                        queryRecords={adminService.queryAllPaymentHistory}
                    />
                }
            </div>
            <div role="tabpanel" hidden={tab !== 1} id="succeeded-tabpanel" aria-labelledby="succeeded-tab">
                {tab === 1 &&
                    <PaymentHistoryTable 
                        history={paymentStore.succeededPaymentHistory}
                        setHistory={paymentStore.setSuccededPaymentHistory}
                        queryHistory={adminService.querySucceededPaymentHistory}
                    />
                }
            </div>
            <div role="tabpanel" hidden={tab !== 2} id="failed-tabpanel" aria-labelledby="failed-tab">
                {tab === 2 && 
                    <PaymentHistoryTable 
                        history={paymentStore.failedPaymentHistory}
                        setHistory={paymentStore.setFailedPaymentHistory}
                        queryHistory={adminService.queryFailedPaymentHistory}
                    />
                }
            </div>
        </Box>
    )
}

export default AdminPaymentHistory;
